import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineRulerIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22.61 7.05 17 1.39a.999.999 0 0 0-.71-.29 1.0002 1.0002 0 0 0-.7.29L1.39 15.54a1 1 0 0 0 0 1.41l5.66 5.66a1.0003 1.0003 0 0 0 .71.29 1.0002 1.0002 0 0 0 .7-.29l2.83-2.83 8.49-8.49 2.83-2.83a.9998.9998 0 0 0 0-1.41Zm-3.54 2.12-.71-.71a.9999.9999 0 0 0-1.41 0 1.001 1.001 0 0 0-.2958.71 1.0013 1.0013 0 0 0 .2958.71l.71.71L16.24 12l-2.12-2.12a.9999.9999 0 0 0-1.6497.7209 1.0003 1.0003 0 0 0 .2397.6891l2.12 2.12-1.42 1.42-.7-.71a1.0041 1.0041 0 1 0-1.42 1.42l.71.7-1.41 1.42-2.13-2.12a.9998.9998 0 0 0-1.41 0 1 1 0 0 0 0 1.41l2.12 2.12-1.41 1.42-4.25-4.25L16.24 3.51l4.25 4.25-1.42 1.41Z"/>
  </SvgIcon>
}

export default LineRulerIcon
